import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

/** 管理员分页列表 GET /system/agents/page */
export function getSystemAgentsList(query = {}) {
  return Api.get(`${BasicConfig.jDomain}/system/agents/page`, { params: { ...query, axiosType: 'java' } })
}

/** 员工详情 GET /system/agents/{id} */
export function getSystemAgentDetail(id) {
  return Api.get(`${BasicConfig.jDomain}/system/agents/${id}`, {
    params: { axiosType: 'java' }
  })
}

/** 新建管理员 POST /system/agents */
export function createSystemAgent(body = {}) {
  return Api.post(`${BasicConfig.jDomain}/system/agents`, {
    ...body,
    axiosType: 'java'
  })
}

/** 更新管理员 PUT /system/agents/{id} */
export function updateSystemAgent(id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/system/agents/${id}`, {
    ...body,
    axiosType: 'java'
  })
}

/** 删除成员 DELETE /system/agents/{id} */
export function deleteSystemAgent(id) {
  return Api.delete(`${BasicConfig.jDomain}/system/agents/${id}`, {
    params: { axiosType: 'java' }
  })
}

/** 查询员工已绑定的系统角色 GET /system/agents/{agentId}/roles */
export function getSystemAgentRoles(agentId) {
  return Api.get(`${BasicConfig.jDomain}/system/agents/${agentId}/roles`, {
    params: { axiosType: 'java' }
  })
}

/** 为员工分配系统角色（全量替换）PUT /system/agents/{agentId}/roles body: { roleIds: "1,2,3" } */
export function putSystemAgentRoles(agentId, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/system/agents/${agentId}/roles`, {
    ...body,
    axiosType: 'java'
  })
}

/** 角色列表 GET /system/roles */
export function getSystemRolesList(query = {}) {
  return Api.get(`${BasicConfig.jDomain}/system/roles`, { params: { ...query, axiosType: 'java' } })
}

/** 权限列表 GET /system/permissions */
export function getSystemPermissionsList(query = {}) {
  return Api.get(`${BasicConfig.jDomain}/system/permissions`, { params: { ...query, axiosType: 'java' } })
}
/** 新建权限 POST /system/permissions */
export function createSystemPermission(body = {}) {
  return Api.post(`${BasicConfig.jDomain}/system/permissions`, {
    ...body,
    axiosType: 'java'
  })
}

/** 更新权限 PUT /system/permissions/{id} */
export function updateSystemPermission(id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/system/permissions/${id}`, {
    ...body,
    axiosType: 'java'
  })
}

/** 删除权限 DELETE /system/permissions/{id} */
export function deleteSystemPermission(id) {
  return Api.delete(`${BasicConfig.jDomain}/system/permissions/${id}`, {
    params: { axiosType: 'java' }
  })
}

/**
 * 新建角色 POST /system/roles
 * @param {object} body id、name、code、dataScope、isDeleted、remark（权限等后续再接）
 */
export function createSystemRole(body = {}) {
  return Api.post(`${BasicConfig.jDomain}/system/roles`, {
    ...body,
    axiosType: 'java'
  })
}

/** 更新角色 PUT /system/roles/{id} */
export function updateSystemRole(id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/system/roles/${id}`, {
    ...body,
    axiosType: 'java'
  })
}

/** 删除角色 DELETE /system/roles/{id} */
export function deleteSystemRole(id) {
  return Api.delete(`${BasicConfig.jDomain}/system/roles/${id}`, {
    params: { axiosType: 'java' }
  })
}

/** 为角色分配权限 PUT /system/roles/{id}/permissions */
export function putSystemRolePermissions(roleId, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/system/roles/${roleId}/permissions`, {
    ...body,
    axiosType: 'java'
  })
}

/** 为权限分配角色 PUT /system/permissions/{id}/roles */
export function putSystemPermissionRoles(permissionId, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/system/permissions/${permissionId}/roles`, {
    ...body,
    axiosType: 'java'
  })
}

/** 按客户（员工）ID 推送 SSE pageReload，硬刷其页面 POST /system/page/reload */
export function postSystemPageReload(body = {}) {
  return Api.post(`${BasicConfig.jDomain}/system/page/reload`, {
    ...body,
    axiosType: 'javaJson'
  })
}
